import { useEffect, useRef, useState } from 'react';
import type { FundingChoice } from '../utils/invoicePanel';

export interface FundingChoiceState {
    choice: FundingChoice | null;
    choose: (next: FundingChoice) => void;
}

export function useFundingChoice(
    overBalance: boolean,
    potTotalAvailable: boolean,
    topUpPending = false,
): FundingChoiceState {
    const [chosen, setChosen] = useState<FundingChoice | null>(null);
    const stale = chosen !== null && (!overBalance || (chosen === 'pot_total' && !potTotalAvailable));
    if (stale) setChosen(null);

    const pendingTopUp = overBalance && topUpPending ? 'top_up' : null;
    return { choice: (stale ? null : chosen) ?? pendingTopUp, choose: setChosen };
}

export function useResetTopUpWhenFits(overBalance: boolean, resetTopUp: () => void): void {
    const wasOverBalance = useRef(overBalance);
    useEffect(() => {
        if (wasOverBalance.current && !overBalance) resetTopUp();
        wasOverBalance.current = overBalance;
    }, [overBalance, resetTopUp]);
}
